import {
  Button,
  Divider,
  Grid,
  IconButton,
  Paper,
  Switch,
  Typography,
} from "@mui/material";
import React from "react";
import WSSCheckBoxField from "../../Components/CheckBox/WSCheckBox";
import { WSIcons } from "../../commonFunctions/iIcons";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import WSTextField, { TextType } from "../../Components/TextBox/WSTextBox";
import { openPopUp } from "../../Components/Dialog/OpenNewModal";
import Message from "./Message";
import { IMetaData } from "../../Components/Dialog/WSCommonDialog";

export const PartySettings: React.FC<any> = React.memo((props) => {
  const { control, register, handleSubmit, setValue, reset, watch } = useForm();
  const navigate = useNavigate();
  // Watch checkbox value
  // Watch each checkbox
  const additionalField1 = watch("Additionalfield", false);
  const additionalField2 = watch("Additionalfield2", false);
  const additionalField3 = watch("Additionalfield3", false);
  const additionalField4 = watch("Additionalfield4", false);
  const handleData = async (data: any) => {
        debugger;
        console.log("onsubmit===>", data); // You can perform any action with the submitted data here
      };

   const handleClick = () => {
          openPopUp(metadata, handleData, "60rem");
        };

         const metadata: IMetaData = {
                title: "Add/Edit Reminder Message",
                hideActions: false,
                content: (props: any, row: any) => (
                    <Message {...props} />
                ),
                actions: [
                    {
                        label: "Cancel",
                        // onClick: handleCloseDialog,
                        className: "ws-cancel",
                        type: "button",
                    },
                    {
                        label: "Save",
                        type: "submit",
                    onClick: handleData,
                        autoFocus: true,
                    },
                ],
                isDragable: true,
            };
        
             const handleCancelClick = () => {
            navigate("/");
          };
  return (
    <Grid p={2}>
      <Paper sx={{ padding: 3, position: "relative" }} elevation={0}>
        {/* Close Icon in top right */}
        <IconButton
          size="small"
          sx={{ position: "absolute", top: 8, right: 8 }}
          onClick={handleCancelClick} // replace with your close logic
        >
          <WSIcons.CloseIcon fontSize="small" />
        </IconButton>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography fontWeight={"bold"}>Party Settings</Typography>
                <Divider />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Party Grouping"
                  id="partyGrouping"
                  control={control}
                  {...register("partyGrouping")}
                  rules={{ required: false }}
                  name="partyGrouping"
                />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Shipping Address"
                  id="shippingAddress"
                  control={control}
                  {...register("shippingAddress")}
                  rules={{ required: false }}
                  name="shippingAddress"
                />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Manage Party Status"
                  id="managePartyStatus"
                  control={control}
                  {...register("managePartyStatus")}
                  rules={{ required: false }}
                  name="managePartyStatus"
                />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Enable Payment Reminder"
                  id="enablePaymentReminder"
                  control={control}
                  {...register("enablePaymentReminder")}
                  rules={{ required: false }}
                  name="enablePaymentReminder"
                />
              </Grid>
              <Grid item xs={12}>
                <WSTextField
                  label={"Remind me for payment due in"}
                  {...register("Remind")}
                  id="Remind"
                  name="Remind"
                  control={control}
                  rules={{ required: true }}
                  type={TextType.Number}
                />
              </Grid>
              <Grid item xs={12}>
                <Button onClick={handleClick}>
                  Reminder Message <WSIcons.ArrowRight />
                </Button>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography fontWeight={"bold"}>Additional fields</Typography>
                <Divider />
              </Grid>
              <Grid item xs={12} sm={1}>
                <WSSCheckBoxField
                  rules={{ required: true }}
                  label=""
                  id="Additionalfield"
                  control={control}
                  {...register("Additionalfield")}
                  name="Additionalfield"
                />
              </Grid>

              <Grid item xs={12} sm={11}>
                <WSTextField
                  label={"Additional field 1"}
                  {...register("Additionalfield1")}
                  id="Additionalfield1"
                  name="Additionalfield1"
                  control={control}
                  rules={{ required: true }}
                  disabled={!additionalField1}
                />

                {/* Toggle Switch based on checkbox */}
                <Switch
                  color="primary"
                  size="small"
                  checked={additionalField1}
                />
              </Grid>
              <Grid item xs={12} sm={1}>
                <WSSCheckBoxField
                  label=""
                  id="Additionalfield2"
                  control={control}
                  {...register("Additionalfield2")}
                  rules={{ required: false }}
                  name="Additionalfield2"
                />
              </Grid>
              <Grid item xs={12} sm={11}>
                <WSTextField
                  label={"Additional field 1"}
                  {...register("Additionalfield1")}
                  id="Additionalfield1"
                  name="Additionalfield1"
                  control={control}
                  rules={{ required: true }}
                  type={TextType.Number}
                />
                <Switch
                  color="primary"
                  size="small"
                  checked={additionalField2}
                />
              </Grid>
              <Grid item xs={12} sm={1}>
                <WSSCheckBoxField
                  label=""
                  id="Additionalfield3"
                  control={control}
                  {...register("Additionalfield3")}
                  rules={{ required: false }}
                  name="Additionalfield3"
                />
              </Grid>
              <Grid item xs={12} sm={11}>
                <WSTextField
                  label={"Additional field 1"}
                  {...register("Additionalfield1")}
                  id="Additionalfield1"
                  name="Additionalfield1"
                  control={control}
                  rules={{ required: true }}
                  type={TextType.Number}
                />
                <Switch
                  color="primary"
                  size="small"
                  checked={additionalField3}
                />
              </Grid>
              <Grid item xs={12} sm={1}>
                <WSSCheckBoxField
                  label=""
                  id="Additionalfield4"
                  control={control}
                  {...register("Additionalfield4")}
                  rules={{ required: false }}
                  name="Additionalfield4"
                />
              </Grid>
              <Grid item xs={12} sm={11}>
                <WSTextField
                  label={"Additional field 1"}
                  {...register("Additionalfield1")}
                  id="Additionalfield1"
                  name="Additionalfield1"
                  control={control}
                  rules={{ required: true }}
                  type={TextType.Number}
                />
                <Switch
                  color="primary"
                  size="small"
                  checked={additionalField4}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography fontWeight={"bold"}>
                  Enable Loyalty Point
                </Typography>
                <Divider />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Enable Loyalty Point"
                  id="EnableLoyaltyPoint"
                  control={control}
                  {...register("EnableLoyaltyPoint")}
                  rules={{ required: false }}
                  name="EnableLoyaltyPoint"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
});
